


















import gql from 'graphql-tag';
import { keyBy, map } from 'lodash';

import { OBJECTS_QUERY } from '@/components/zen_objects_dropdown/graphql/queries';
import ZenObjectsDropdown from '@/components/zen_objects_dropdown/ZenObjectsDropdown.vue';

import { filterPresenterMixin } from './common';

export const codesToFilter = (codes: string[]) => {
  const filter = {
    left: 'code',
    op: {
      name: 'in_array',
    },
    right: codes,
  };

  return JSON.stringify(filter);
};

export default {
  name: 'ObjectFilterAttributePresenter',
  components: {
    ZenObjectsDropdown,
  },
  props: {
    ...filterPresenterMixin.props,
  },
  computed: {
    internalValue(): string {
      if (!this.preselectedObjects) return '';

      return map(this.preselectedObjects.edges, o => o.node.id);
    },
  },
  methods: {
    /**
     * Get object type for the given attribute, which is the same as "displayName"
     * field for attributes meta.
     * i.e. for "relevantPrograms" on Objective, the attribute meta is:
     * {
     *   "name": "relevantPrograms",
     *   "displayName": "Program",
     * },
     */
    objectTypeForAttribute(attribute: string): string {
      // TODO: temp, handles Asessments attribute on Control
      if (attribute == 'assessments') return 'Assessment';

      return this.attributeMeta[attribute].displayName;
    },

    onObjectChange(object): void {
      this.$emit('input', object.code);
    },
  },
  apollo: {
    attributeMeta: {
      query: gql`
        query Attributes($objectType: SearchType!, $context: AttributesContext!) {
          objectType(name: $objectType) {
            attrs(context: $context) {
              name
              displayName
            }
          }
        }
      `,
      variables() {
        return {
          objectType: this.objectType,
          context: 'SOR_LISTING',
        };
      },
      update: data => keyBy(data.objectType.attrs, 'name'),
    },
    preselectedObjects: {
      // TODO: during dev only, remove
      fetchPolicy: 'network-only',

      query() {
        return OBJECTS_QUERY;
      },
      variables() {
        return {
          objectType: this.objectTypeForAttribute(this.attribute),
          pageSize: 1000, // give it all at once
          page: 1,
          order: { by: 'title', direction: 'ASC' },
          filter: codesToFilter([this.value]),
        };
      },
      update(data) {
        return data.objects;
      },
    },
  },
};
